module.exports = __webpack_public_path__ + "static/media/BoxPlotQ4_3.f15ca8e2.svg";